interface ClusterMember {
  _id?: string | undefined;
}

export interface ClusterRow extends Record<string, unknown> {
  _id?: string | undefined;
  number?: string | undefined;
  createdAt?: string | undefined;
  reOrders?: ClusterMember[] | undefined;
  parentDevOrderId?: string | undefined;
}

/**
 * Builds the product-list row that shows one member of a reorder cluster.
 *
 * `_id`, `number` and `createdAt` stay the cluster parent's. The card builds its order dropdown
 * from those three, so carrying the member's `createdAt` across re-sorts the options and the next
 * render defaults to a different order — the card then flips between members on its own.
 *
 * Returns null when the slot no longer holds the cluster the detail was fetched for: the list is
 * replaced on every refetch while a detail request is in flight, and writing the response into a
 * moved slot shows one product's data under another product's number.
 * @param clusterRow the row currently in the list at that position
 * @param memberDetail the fetched cluster member, in list shape
 * @param memberId the id the detail was fetched for
 * @returns the merged row, or null when it must not be written
 */
export const swapClusterRow = (clusterRow: ClusterRow | undefined, memberDetail: ClusterRow, memberId: string): ClusterRow | null => {
  if (!clusterRow) return null;
  const belongsToRow =
    String(clusterRow._id) === String(memberId) || (clusterRow.reOrders || []).some((member) => String(member?._id) === String(memberId));
  if (!belongsToRow) return null;
  return {
    ...memberDetail,
    _id: clusterRow._id,
    number: clusterRow.number,
    createdAt: clusterRow.createdAt,
    reOrders: clusterRow.reOrders,
    clusterId: memberDetail.parentDevOrderId ? memberId : null,
  };
};
